import type { TFunction } from 'i18next';

const ATS_MANAGED_JOB_FIELDS = [
  'title',
  'description',
  'specialization',
  'working_type',
  'salary_from',
  'salary_max',
  'compensation_currency',
] as const;

type AtsManagedJobField = (typeof ATS_MANAGED_JOB_FIELDS)[number];

const ATS_MANAGED_JOB_FIELD_SET = new Set<string>(ATS_MANAGED_JOB_FIELDS);

const EMPLOYMENT_TYPE_FIELD_TO_ATS_KEY: Record<string, AtsManagedJobField> = {
  'permanent/salary': 'salary_from',
  'permanent/salary_max': 'salary_max',
  'freelance/rate': 'salary_from',
  'freelance/rate_max': 'salary_max',
  'ctp/salary': 'salary_from',
  'ctp/salary_max': 'salary_max',
};

export function resolveAtsManagedFieldKey(fieldKey: string): string {
  return EMPLOYMENT_TYPE_FIELD_TO_ATS_KEY[fieldKey] ?? fieldKey;
}

export function isAtsManagedField(fieldKey: string): boolean {
  return ATS_MANAGED_JOB_FIELD_SET.has(resolveAtsManagedFieldKey(fieldKey));
}

function hasSyncedAtsValue(syncedValue: unknown): boolean {
  if (syncedValue == null) {
    return false;
  }
  if (typeof syncedValue === 'string') {
    return syncedValue.trim() !== '';
  }
  if (typeof syncedValue === 'number') {
    return !Number.isNaN(syncedValue);
  }
  return true;
}

export function isAtsLockedField(
  isAtsConnected: boolean | undefined,
  fieldKey: string,
  syncedValue: unknown,
): boolean {
  return (
    Boolean(isAtsConnected) &&
    isAtsManagedField(fieldKey) &&
    hasSyncedAtsValue(syncedValue)
  );
}

export function atsSyncedFieldHelp(
  locked: boolean,
  t: TFunction,
): string | undefined {
  return locked ? t('JOB_FIELD_SYNCED_FROM_ATS') : undefined;
}
